// extracted by mini-css-extract-plugin
export default {"main":"CustomPagesAdd_main__JyCez"};